/**
 * Name of the parent community route.
 *
 * Lives here rather than in `app/community/routes` because composables and stores that only need
 * the string were importing the whole route table, and with it every async-imported community page.
 * That closed a 36-module import cycle and inflated what Stryker's `related` walk has to run.
 */
export const communityRouteName = 'community';
